module.exports = __webpack_public_path__ + "assets/img/title.34facc09.svg";